export default "__VITE_ASSET__0pU7NxGI__"